import React, { createContext, useContext, useState, Dispatch, SetStateAction } from 'react';
import { SearchAppState } from '@coveo/headless';

type SearchContextType = {
  ContextResults: SearchAppState['search'] | null;
  setContextResults: Dispatch<SetStateAction<SearchAppState['search'] | null>>;
};

export const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider = ({ children }: { children: React.ReactNode }) => {
  const [ContextResults, setContextResults] = useState<SearchAppState['search'] | null>(null);

  return (
    <SearchContext.Provider value={{ ContextResults, setContextResults }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = (): SearchContextType => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};
